<script>
import aliPayDialog from '@/components/aliPayDialog.vue'
export default {
  name: "smsConfig",
  components: { aliPayDialog },
  data() {
    return {
      tableData: [],
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/sms/balance/record',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: "radioGroup",
            field: "timeType",
            name: "时间段",
            value: "3",
            option: [
              {label: '今日', value: "0"},
              {label: '昨日', value: "1"},
              {label: '最近30天', value: "3"},
            ],
          },
          {type: "datetime", field: "time", name: "发送时间", value: []},
        ]
      },
      // 表头
      columns: [
        {prop: 'type', label: '类型'},
        {prop: 'remark', label: '描述', width: 740},
        {prop: 'beforeBalance', label: '操作前条数'},
        {prop: 'afterBalance', label: '操作后条数'},
        {prop: 'created', label: '记录时间'},
      ],
      form: {
        settleType: ""
      },
      show: false,
      loading: false,
      smsBalance: null,
    }
  },
  mounted() {
    this.getInitFn()
    this.getSmsBalance()
  },
  methods: {
    async getSmsBalance() {
      try {
        const { code, data } = await this.$axios.get('/api/v1/manage/sms/count', { appKey: this.mixinUserInfo?.appKey })
        if (code === 1 && data) {
          this.smsBalance = data.smsBalance != null ? data.smsBalance : (data.smsCount != null ? data.smsCount : null)
        }
      } catch (e) { console.error(e) }
    },
    rechargeClick() {
      this.$refs.aliPayDialog.rechargeOpen('SMS_FEE')
    },
    paySuccess() {
      this.getSmsBalance()
      this.$refs.customTable.listFn()
    },
    async getInitFn() {
      const url = "/api/v1/manage/sms/config"
      const {code, data} = await this.$axios.get(url, { appKey: this.mixinUserInfo?.appKey })

      if (code === 1 && data) {
        this.form.settleType = data
      }
    },
    async onSubmit() {
      this.loading = true
      const url = "/api/v1/manage/sms/config"
      const {code} = await this.$axios.post(url, { ...this.form, appKey: this.mixinUserInfo?.appKey })
      this.loading = false
      if (code === 1) {
        this.$message.success('操作成功')
        this.getInitFn()
        this.$refs.customTable.listFn()
        this.handClose()
      }
    },
    handClose() {
      this.show = false
    }
  }
}
</script>

<template>
  <div class="smsConfig">
    <el-dialog
        :title="form.settleType ===1?`平台统一结算`:'机构单独结算'"
        :before-close="handClose"
        :visible.sync="show"
        :close-on-click-modal="false"
        destroy-on-close
        width="420px"
    >

      <div v-if="form.settleType ===1">
        <div style="margin-bottom: 10px">开启平台统一结算后，我们将做如下账户变更
        </div>
        <div class="blueInfo">
          <p>* 各机构共用平台的短信余额</p>
          <p>* 各机构充值短信余额归入平台短信余额</p>
          <p>* 各机构短信余额将清零</p>
        </div>
      </div>
      <div v-else>
        <div style="margin-bottom: 10px">开启机构单独结算后，我们将做如下账户变更
        </div>
        <div class="blueInfo">
          <p>* 各机构单独充值短信余额</p>
          <p>* 平台已有余额默认归入总机构账户余额</p>
          <p>* 各机构短信余额置为0</p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <custom-table excel-type="SmsBalanceRecord" :labelWidth="140" ref="customTable"
                  :customOptions="customOptions" :columns="columns"
                  has-organization="true"
    >
      <template slot="customTable-top">
        <div slot="customTable-top">

          <div class="sms-balance-bar" v-if="smsBalance !== null">
            <span class="balance-label">当前短信余额：</span>
            <span class="balance-value" :class="smsBalance < 100 ? 'balance-warn' : 'balance-ok'">
              {{ smsBalance }} 条
            </span>
            <el-tag v-if="smsBalance < 100" type="warning" size="mini" style="margin-left: 8px">余额不足，请及时充值</el-tag>
            <el-button type="primary" size="mini" style="margin-left: auto" @click="rechargeClick">立即充值</el-button>
          </div>

          <div class="blueInfo">
            <p>* 切换为平台统一结算，机构短信余额统一归入平台短信余额，各个机构短信账户余额设置为0</p>
            <p>*
              切换为机构单独结算，平台短信余额将归入总机构短信余额，其余机构短信余额设置为0，使用前各机构需单独充值使用</p>
            <p>* 仅总机构管理员可切换短信账户结算模式</p>
          </div>
          <el-form label-position="left" ref="form" :model="form" label-width="140px">
            <el-form-item label="短信账户结算">
              <el-radio-group v-model="form.settleType">
                <div class="radio-option">
                  <el-radio :label="1">平台统一结算</el-radio>
                  <span class="option-desc">短信余额由平台充值，下属机构共同使用平台的短信余额</span>
                </div>
                <div class="radio-option">
                  <el-radio :label="2">机构单独结算</el-radio>
                  <span class="option-desc">短信余额由机构充值，机构仅可使用自己充值的短信余额</span>
                </div>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="show = true">保存配置</el-button>
            </el-form-item>
          </el-form>


          <div class="blueInfo">
            <p>* 平台充值、机构充值及总机构管理员切换账户结算模式时皆会产生账户变更记录</p>
            <p>* 短信余额使用记录请前往短信记录查询</p>
          </div>

        </div>
      </template>


      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'type'">{{ row.type | filterConst('BALANCETYPE') }}</template>
        <template v-else-if="item.prop === 'beforeBalance'">{{ row.beforeBalance || 0 }}</template>
        <template v-else-if="item.prop === 'afterBalance'">{{ row.afterBalance || 0 }}</template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>

    <aliPayDialog ref="aliPayDialog" @success="paySuccess"></aliPayDialog>
  </div>
</template>

<style scoped lang="less">
.smsConfig {
  // 顶部配置区域
  .blueInfo {
    margin-bottom: 16px;
  }

  .el-form {
    background: #fff;
    padding: 20px 24px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

    .el-form-item__label {
      font-weight: 500;
      color: #303133;
    }
  }

  // 单选按钮组样式
  .radio-option {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: #f5f7fa;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover {
      background: #eef3ff;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .el-radio {
      margin-right: 12px;
      
      .el-radio__label {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
      }
    }

    .option-desc {
      font-size: 12px;
      color: #909399;
      line-height: 1.5;
      margin-top: 2px;
    }
  }

  // 短信余额栏
  .sms-balance-bar {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: #f0f9ff;
    border: 1px solid #bae0ff;
    border-radius: 6px;
    margin-bottom: 16px;
    font-size: 14px;

    .balance-label { color: #606266; }
    .balance-ok { color: #52c41a; font-weight: 600; font-size: 16px; }
    .balance-warn { color: #fa8c16; font-weight: 600; font-size: 16px; }
  }

  // 保存按钮
  .el-form-item:last-child {
    margin-bottom: 0;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
    
    .el-button {
      min-width: 100px;
      border-radius: 6px;
    }
  }
}
</style>